export default class Cliente {
  constructor(id, nome, cnpj, endereco, bairro, cidade, uf, telefone, email) {
    this.id = id;
    this.nome = nome;
    this.cnpj = cnpj;
    this.endereco = endereco;
    this.bairro = bairro;
    this.cidade = cidade;
    this.uf = uf;
    this.telefone = telefone;
    this.email = email;
  }

  update(cliente) {
    this.id = cliente.id;
    this.nome = cliente.nome;
    this.cnpj = cliente.cnpj;
    this.endereco = cliente.endereco;
    this.bairro = cliente.bairro;
    this.cidade = cliente.cidade;
    this.uf = cliente.uf;
    this.telefone = cliente.telefone;
    this.email = cliente.email;
  }
}
